export interface ReactRouterLocation<S extends any = unknown> {
  hash: string;
  key: string;
  pathname: string;
  search: string;
  state: S;
}

export interface ReactRouterHistory extends Record<string, any> {
  listen?: (cb: (location: ReactRouterLocation, action: NavigationType) => void) => void;
  location?: ReactRouterLocation;
}

export enum ReactRouterVersion {
  V4 = 'v4',
  V5 = 'v5',
  V6 = 'v6',
  V6_data_router = 'v6_data_router',
  V7 = 'v7',
  V7_data_router = 'v7_data_router',
}

export enum NavigationType {
  Pop = 'POP',
  Push = 'PUSH',
  Replace = 'REPLACE',
}
